import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Storage from "../utills/AsyncStorage";
import styles from "./layoutstyle.module.css";
import { Button, Result } from "antd";
import { roles } from "../config/roles";

export const HomeLayout = () => {
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  const user = useSelector((state) => state.AuthReducer.user);
  console.log("user====>>>>>>>>>", user);

  // const role = "admin";
  const role = localStorage.getItem("@role");

  // const role = Storage.getERole("@role");
  const navigate = useNavigate();

  console.log("Role -->", role);

  if (isLogin == true) {
    return (
      <Navigate
        to={
          role == roles.admin
            ? "/AdminDashboard"
            : role == roles.supervisor
            ? "/SupervisorDashboard"
            : "/StaffDashboard"
        }
      />
    );
  }
  return (
    <div className={styles.publiclayoutContainer}>
      <Outlet />
    </div>
  );
};

export const RolesLayout = ({ roles }) => {
  // const role = localStorage.getItem("role");
  const role = localStorage.getItem("@role");
  console.log("role", role, roles?.includes(role), roles);
  const navigate = useNavigate();
  if (!roles?.includes(role)) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};
